import React, { useRef, useEffect, useState } from 'react';

const WidgetChart = ({ chartHTML, isTableChart, rawSqlResponse }) => {
  const iframeRef = useRef(null);
  const isInvestmentBanker = sessionStorage.getItem('role')?.toLowerCase() === 'investment banker';
  const [insightsOpen, setInsightsOpen] = useState(!isInvestmentBanker);

  useEffect(() => {
    function onMessage(e) {
      if (e?.data?.type === 'EMBED_HEIGHT' && iframeRef.current) {
        if (isTableChart && e.data.h > 500) {
          iframeRef.current.parentElement.style.overflowY = 'auto';
        }
      }
    }
    
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, [isTableChart]);

  return (
    <div className="visualization-container">
      {chartHTML && (
        <>
          <div
            className={`chart-wrapper rounded bg-white ${
              isTableChart ? 'resize overflow-hidden' : 'overflow-auto'
            }`}
            style={{ maxHeight: '700px', height: '350px', maxWidth: '100%' }}
          >
            <iframe
              ref={iframeRef}
              src={chartHTML}
              title="Chart"
              className="border-none w-full"
              style={{ display: 'block', backgroundColor: 'white', height: '100%' }}
            />
          </div>
          {rawSqlResponse && (
            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-lg text-sm border border-blue-100 shadow-sm overflow-hidden">
              <button
                onClick={() => setInsightsOpen(o => !o)}
                className={`w-full flex items-center gap-2 p-4 ${insightsOpen ? 'pb-0' : ''} text-left focus:outline-none`}
              >
                <div className="w-1 h-5 bg-primary rounded shrink-0"></div>
                <h4 className="m-0 text-sm font-semibold text-primary flex-1">Key Insights</h4>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className={`w-4 h-4 text-primary transition-transform duration-200 ${insightsOpen ? 'rotate-180' : ''}`}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </button>
              {insightsOpen && (
                <div
                  className="text-gray-700 p-4 pt-3"
                  dangerouslySetInnerHTML={{ __html: rawSqlResponse }}
                />
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default WidgetChart;